<template lang="pug">
    .put-aside
        .body(v-loading="loading")
            //- .under-construction
            //-     i.el-icon-fa-snowplow.fas
            //-     h4 {{ $t('Under Construction') }}
            //-     p {{ $t('Come back another time') }}
            .tab-content.scroll-box.put-aside(v-dragscroll)
                .empty(v-if="! loading && (! purchases || ! purchases.length)")
                    //- i.el-icon-fa-ghost.fas
                    .icon
                        i.el-icon-fa-slash.fas
                        i.el-icon-fa-circle.far
                    h4 {{ $t('Empty List') }}
                    p {{ $t('There is nothing to see here!') }}
                transition-group(v-else name="slide-decent-vertical" tag="div")
                    purchase-on-hold(
                        v-for="purchase in purchases"
                        :key="purchase.id"
                        :purchase="purchase"
                    )
        .foot(v-if="!purchaser.customer")
            .actions
                el-button.action(
                    :plain="showOnlyOwnPurchasesOnHold"
                    type="primary"
                    icon="el-icon-fa-network-wired fas"
                    :disabled="loading"
                    @click="toggleShowOnlyOwnPurchasesOnHold"
                )
                .placeholder.gray-box.grow
</template>

<i18n>
{
    "de": {
        "Empty List": "Leere Liste",
        "There is nothing to see here!": "Hier gibt es nichts zu sehen!"
    }
}
</i18n>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';

import PurchaseOnHold from './Partials/PurchaseOnHold'

export default {
    name: 'PutAside',
    components: {
        PurchaseOnHold,
    },
    computed: {
        ...mapGetters({
            cartPurchaseID: 'ext_pos_cart/id',
            loading: 'ext_pos_setup/loadingPurchasesOnHold',
            purchases: 'ext_pos_setup/purchasesOnHold',
            purchaser: 'ext_pos_cart/purchaser',
            showOnlyOwnPurchasesOnHold: 'ext_pos_setup/showOnlyOwnPurchasesOnHold',
        })
    },
    methods: {
        toggleShowOnlyOwnPurchasesOnHold() {
            this.updateShowOnlyOwnPurchasesOnHold(!this.showOnlyOwnPurchasesOnHold)
            this.fetchPurchasesOnHold()
        },
        ...mapMutations({
            updateShowOnlyOwnPurchasesOnHold: 'ext_pos_setup/updateShowOnlyOwnPurchasesOnHold',
        }),
        ...mapActions({
            fetchPurchasesOnHold: 'ext_pos_setup/fetchPurchasesOnHold',
        })
    },
    mounted() {
        this.$emit('focus-search')
    }
}
</script>

<style lang="sass" scoped>
.tab-content
    width: 100%
    display: flex
    flex-direction: column

.body
    min-height: 10rem
    position: relative
    flex-grow: 1
    /* overflow-x: hidden */
    /* overflow-y: auto */
    /* max-height: 100% */
    /* max-height: calc(100vh - 140px) */
    .scroll-box
        padding: 1rem
        position: absolute
        left: 0
        top: 0
        width: 100%
        height: 100%
        // height: calc(100% - 2px)
        overflow-x: hidden
        overflow-y: auto

.under-construction
    flex-grow: 1
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    padding: 4rem
    text-align: center
    i
        font-size: 4rem
        color: rgba(0,0,0,0.2)
    h4
        margin-top: 1rem
        margin-bottom: 0
        font-size: 2rem
        font-weight: 300
        color: rgba(0,0,0,0.3)

.foot
    padding: 1rem
    display: grid
    gap: 0.5rem
    grid-template-rows: 50px
    grid-template-columns: repeat(12, minmax(0, 1fr))
    .gray-box
        height: 50px
        background: darken($color-skeleton, 10%)
        padding: 4px 1rem
        padding-bottom: 6px
        border-radius: 4px
        &.placeholder
            // background: darken($color-skeleton, 5%)
    .actions
        grid-column: 1 / -1
        display: flex
        gap: 0.5rem
        .grow
            flex-grow: 1
        .action
            font-size: 1.4rem
            &::v-deep > i.el-icon-loading
                width: 1.4rem
                height: 1.4rem
                &:after
                    width: 1.4rem
                    height: 1.4rem
                    left: calc(50% - 0.7rem)
                    top: calc(50% - 0.7rem)
</style>
